import * as yup from "yup";

import { t } from "@/i18n-js/instance";

const i18nRoot = "settings.navigation.add_link_modal.form";

export const VISIBILITY_OPTIONS = [
  "enabled",
  "disabled",
  "admin_only",
] as const;

export const EVERYONE = "everyone";
export const LOGGED_IN = "logged_in";
export const LOGGED_OUT = "logged_out";
export const AUDIENCE_OPTIONS = [EVERYONE, LOGGED_IN, LOGGED_OUT] as const;

export const ADD_LINK_FORM_DEFAULT_VALUES = {
  name: "",
  url: "",
  open_in_new_window: "true",
  visibility: VISIBILITY_OPTIONS[0],
};

export const ADD_LINK_FORM_VALIDATION_SCHEMA = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required(() => t(`${i18nRoot}.name.required`))
    .max(20, () => t(`${i18nRoot}.name.max_length`)),
  url: yup
    .string()
    .url(() => t(`${i18nRoot}.url.invalid`))
    .required(() => t(`${i18nRoot}.url.required`)),
  open_in_new_window: yup.string().required(),
  visibility: yup
    .string()
    .oneOf(["enabled", "disabled", "admin_only"])
    .required(),
});
